<template>
    <div class="parallax-container" :class="rootClasses">
        <slot/>
    </div>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import Parallax from 'scroll-parallax/dist/Parallax';
    import { loadImages } from 'bianco.images-loader';
    import $ from 'bianco.query';
    import { mapState } from 'vuex';

    export default {
        mixins: [bemMixin('parallax-container')],
        data() {
            return {
                isReady: false,
            };
        },
        computed: {
            ...mapState('viewport', ['mq']),
            rootClasses() {
                return [
                    this.bemFacets,
                    this.bemIf(this.isReady, 'is-ready'),
                ];
            },
        },
        methods: {
            refreshParallaxOnImagesLoaded() {
                loadImages($('img', this.$el)).then(() => {
                    this.parallax.refresh();
                });
            },
        },
        watch: {
            'mq.query': {
                immediate: false,
                handler(currentValue, oldValue) {
                    if (!oldValue || !this.parallax) {
                        return;
                    }

                    this.refreshParallaxOnImagesLoaded();
                },
            },
        },
        mounted() {
            const items = $('[data-parallax]', this.$el);

            if (!items.length) {
                return;
            }

            this.parallax = new Parallax(items);
            this.parallax.init();

            this.parallax.on('elements:loaded', () => {
                this.isReady = true;
            });
        },
        beforeDestroy() {
            this.parallax.destroy();
        },
    };
</script>
